export const API_URL = import.meta.env.VITE_API_URL;
export const TIGRIS_DATA_PUBLIC_BUCKET_URL = import.meta.env
  .VITE_TIGRIS_DATA_PUBLIC_BUCKET_URL;
export const GDRIVE_WORKS_FOLDER_ID = "1VKFAcvam1ZWZg0THSEo_GV64YhphjRYp";
